import { z } from 'zod';
import { personalInfoBlock } from './blocks/personalInfo';
import { addressBlock } from './blocks/address';
import { contactBlock } from './blocks/contact';
import { employmentBlock } from './blocks/employment';
import * as identity from '../primitives/identity';
import { RequiredMessage } from '../validation/messages';

/**
 * Reference entity schema — demonstrates how blocks compose into a
 * business object. This is NOT a usable form schema; real form schemas
 * live in src/apps/customer/ and use .extend() / .partial() / .omit()
 * to override per-form requirements.
 */
export const participantSchema = personalInfoBlock.extend({
  email: identity.email.schema,
  ssn: identity.ssn.schema.optional(),
  homeAddress: addressBlock,
  mailingAddress: addressBlock.partial(),
  previousAddresses: z
    .array(
      addressBlock.extend({
        startDate: z.string().min(1, RequiredMessage),
        endDate: z.string().optional(),
      }),
    )
    .optional(),
  contact: contactBlock,
  employment: employmentBlock,
});

export type Participant = z.infer<typeof participantSchema>;
